import { ValidationError } from "yup";

export interface ProjectSectionsProps {
  fieldHasError: (field: string) => boolean;
  getErrorByField: (field: string) => string | undefined;
  generateBaseFieldProps: (name: ProjectFields) => BaseFieldProps;
  viewOnly?: boolean;
  errors?: ValidationError[];
}

export interface BaseFieldProps {
  error: boolean;
  errorMessage: string | undefined;
  "data-cy": string;
  dataCy: string;
  label: string;
  placeholder: string;
  "aria-label": ProjectFields;
  disabled: boolean | undefined;
  name: ProjectFields;
  value: any;
}

export enum ProjectTabsTabs {
  DETAILS = "details",
  FILES = "files",
}

export enum ProjectDetailsFields {
  NAME = "name",
  CUSTOMER_NAME = "customerName",
  START_DATE = "startDate",
  END_DATE = "endDate",
  EMAIL = "email",
  EMAIL_HOST = "emailHost",
  EMAIL_PORT = "emailPort",
  EMAIL_USER = "emailUser",
  EMAIL_PASSWORD = "emailPassword",
  STATUS = "status",
  EMAIL_TLS = "emailTls",
}

export type ProjectFields = ProjectDetailsFields;
